import React from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsSection } from './components/MetricsSection';
import { TestimonialsShort } from './components/TestimonialsShort';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { SixTomos } from './components/SixTomos';
import { ThreeBonus } from './components/ThreeBonus';
import { UrgencyPrice } from './components/UrgencyPrice';
import { OfferCards } from './components/OfferCards';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsLong } from './components/TestimonialsLong';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-text-main overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <MetricsSection data-id="element-2" />
      <TestimonialsShort data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductPresentation data-id="element-5" />
      <SixTomos data-id="element-6" />
      <ThreeBonus data-id="element-7" />
      <UrgencyPrice data-id="element-8" />
      <OfferCards data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <TestimonialsLong data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}